import { createState } from '@hookstate/core';
import { PermissionMap } from '~types/permissionModels';

const permissionStore = createState<PermissionMap>({});

export default permissionStore;
